import React, { Component } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from '../../utils/RecordsPagination';

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

// material ui icons
import EditIcon from "@material-ui/icons/Edit";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  Grid,
  Input,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  input: {
    marginTop: "0 !important"
  },
  nb: {
    color: "red",
    fontSize: "12px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "67%"
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
    marginTop: "0px",
    width: '100%'
  },
  icon: {
    margin: "8px 0px 8px 0px",
    position: "relative",
    top: "7px",
    paddingLeft: "8px",
  }
});

const CustomTableCell = withStyles(theme => ({
  head: {
    color: " #66bb6a",
    fontSize: "14px",
    fontWeight: "lighter"
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

function ReconciliationTableStructure(props) {
  const { classes, reconciliationData, filterAirlines,
    filterStatus, openEditModal, closeEditModal, isEditModalOpen,
    handleUpdate, newAirlineId, airlines, selectAirlineChange,
    selectTypeChange, handleChange, error, formError, newType, newToken,
    newTokenRate, narration, pendingReconId, reconciliationTypes,
    airlineError, tokenError, narrationError, typeError,airports,
    newAirportCode,airportError,filterAirport, disabled
  } = props

  return (

    <div>

      {/* Edit Reconciliation Modal */}
      < Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={isEditModalOpen}
        onClose={closeEditModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: "#66bb6a" }}>
          <span style={{ color: "white", textTransform: "uppercase" }}> Edit Reconciliation</span>
        </DialogTitle>
        <DialogContent style={{ marginTop: "20px" }}>
          <Grid container spacing={24}>
            <Grid item md={12} xs={12}>

              {error && <span style={{ color: 'red' }}>{formError}</span>}

              <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                <InputLabel shrink htmlFor="airlineId">Airline</InputLabel>
                <Select
                  value={newAirlineId}
                  onChange={selectAirlineChange("newAirlineId")}
                  // inputProps={{
                  //   name: 'airlineId',
                  //   id: 'airline',
                  // }}
                  name="AirlineId"
                  input={<Input name="airline" id="airline-label-placeholder" />}
                >
                  <MenuItem value="Placeholder">Select Airline</MenuItem>
                  {airlines.map((option, i) => (
                    <MenuItem
                      key={i}
                      value={option.AirlineId}
                      className={classes.select}
                    >
                      {option.Airline}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {airlineError && <span style={{ color: 'red' }}>{"Valid Airline is required"}</span>}

            </Grid>
            <Grid item md={12} xs={12}>

                {error && <span style={{ color: 'red' }}>{formError}</span>}

              <FormControl
                  className={classNames(classes.airlineSelect, classes.formControl)}
              >
                <InputLabel shrink htmlFor="age-label-placeholder">
                  Airports
                </InputLabel>
                <Select
                    value={newAirportCode}
                    onChange={selectAirlineChange("newAirportCode")}
                    input={<Input name="newAirportCode" id="newAirportCode-label-placeholder" />}
                    // displayEmpty
                    name="newAirportCode"
                    className={classes.selectEmpty}
                >
                  <MenuItem value="-1">All Airports</MenuItem>
                    {airports.map((option, i) => (
                        <MenuItem
                            key={i}
                            value={option.Code}
                            className={classes.select}
                        >
                            {option.Name}
                        </MenuItem>
                    ))}
                </Select>
              </FormControl>
                {airportError && <span style={{ color: 'red' }}>{"Valid Airport is required"}</span>}

            </Grid>

            <Grid item md={12} xs={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Token"
                id="newToken"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={
                  {
                    name: "newToken",
                    type: "number",
                    value: newToken,
                    onChange: handleChange,
                  }}
              />
              {tokenError && <span style={{ color: 'red' }}>{"Valid Token is required"}</span>}
            </Grid>

            <Grid item md={12} xs={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Token Rate"
                id="newTokenRate"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={
                  {
                    name: "newTokenRate",
                    type: "number",
                    value: newTokenRate,
                    disabled: true
                  }}
              />
              {error && <span style={{ color: 'red' }}>{formError}</span>}
            </Grid>

            <Grid item md={12} xs={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Narration"
                id="narration"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={
                  {
                    name: "narration",
                    type: "text",
                    value: narration,
                    onChange: handleChange,
                  }}
              />
              {narrationError && <span style={{ color: 'red' }}>{"Valid Narration is required"}</span>}
            </Grid>

            <Grid item md={12} xs={12}>
              <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                <InputLabel shrink htmlFor="reconciliation">Reconciliation Type</InputLabel>
                <Select
                  value={newType}
                  onChange={selectTypeChange("newType")}
                  // inputProps={{
                  //   name: 'airlineId',
                  //   id: 'airline',
                  // }}
                  name="newType"
                  input={<Input name="Type" id="airline-label-placeholder" />}
                >
                  {/*<MenuItem value="Placeholder">Select Reconciliation Type</MenuItem>*/}
                  {reconciliationTypes.map((option, i) => (
                    <MenuItem
                      key={i}
                      value={option.value}
                      className={classes.select}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {typeError && <span style={{ color: 'red' }}>{"Valid Reconciliation Type is required"}</span>}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditModal} color="danger">
            Cancel
          </Button>
          <Button disabled={disabled} onClick={() => handleUpdate(pendingReconId)} color="primary" autoFocus>
            Update
          </Button>
        </DialogActions>
      </Dialog >

      <div className={classes.tableResponsive}
        style={{ overflowX: "auto" }}>
        <Table className={classes.table} aria-labelledby="tableTitle">
          <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
              {/* <TableCell >S/No</TableCell> */}
              <CustomTableCell >Airline <br /> Name</CustomTableCell>
              <CustomTableCell >Airport <br /> Name</CustomTableCell>
              <CustomTableCell >Token</CustomTableCell>
              <CustomTableCell >Token <br /> Rate (&#8358;)</CustomTableCell>
              <CustomTableCell >Token <br /> Amount (&#8358;)</CustomTableCell>
              <CustomTableCell >Narration</CustomTableCell>
              {/* <CustomTableCell >Created <br /> By</CustomTableCell> */}
              <CustomTableCell >Created <br /> Date</CustomTableCell>
              {/* <CustomTableCell >Processed <br /> By</CustomTableCell> */}
              {/* <CustomTableCell >Processed <br /> Date</CustomTableCell> */}
              <CustomTableCell >Is <br /> Credit</CustomTableCell>
              <CustomTableCell >Status</CustomTableCell>
              <CustomTableCell >Comments</CustomTableCell>
              <CustomTableCell >Actions</CustomTableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {reconciliationData.map((item, key) => {
              return (
                <TableRow hover key={item.Id}>
                  {/* <TableCell >{key + 1}</TableCell> */}
                  <TableCell >{filterAirlines(item.AirlineId)}</TableCell>
                    {/*filterAirport*/}
                  <TableCell>{filterAirport(item.AirportCode)}</TableCell>
                  <TableCell >{appHelpers.numberWithCommasOnly(item.Token)}</TableCell>
                  <TableCell >{appHelpers.numberWithCommas(item.TokenRate)}</TableCell>
                  <TableCell >&#8358; {appHelpers.numberWithCommas(item.Amount)}</TableCell>
                  <TableCell >{item.Narration}</TableCell>
                  {/* <TableCell >{filterUsers(item.CreatedBy)}</TableCell> */}
                  <TableCell >{(item.CreatedDate) ? appHelpers.formatDate(item.CreatedDate, "MMM DD, YYYY") : ""}</TableCell>
                  {/* <TableCell >{filterUsers(item.ProcessedBy)}</TableCell> */}
                  {/* <TableCell >{(item.ProcessDate) ? appHelpers.formatDate(item.ProcessDate, "MMM DD, YYYY") : ""}</TableCell> */}
                  <TableCell >{(item.Iscredit) ? "Yes" : "No"}</TableCell>
                  <TableCell >{filterStatus(item.Status)}</TableCell>
                  <TableCell >{(item.Comments ? item.Comments : "")}</TableCell>
                  {item.Status === 0 && <TableCell >
                    <span
                      onClick={() => openEditModal(item)}
                      style={{ cursor: "pointer", color: "#ff9800", padding: "0 5px", float: "left" }}
                    >
                      <span className={classes.icon}>
                        <EditIcon />
                      </span>
                      Edit
                    </span>
                  </TableCell> }

                   {item.Status === 1 && <TableCell>
                    <span
                      style={{
                        cursor: "pointer", backgroundColor: "#43a047",
                        borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                      }}
                    >
                      Approved
            </span>
                  </TableCell>}

                  {item.Status === 2 && <TableCell>
                    <span
                      style={{
                        cursor: "pointer", backgroundColor: "#dd2735",
                        borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                      }}
                    >
                      Declined
            </span>
                  </TableCell>}

                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            {/*<RecordPagination fetchMore={fetchPayments} totalCount={totalPaymentCount} pageSize={pageSize} currentPage={currentPage} target={<AirlinesTable/>}/>*/}
            {/*<TableRow />*/}
          </TableFooter>
        </Table>

      </div >
    </div >
  );
}

class MyReconciliationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { classes, reconciliationData, fetchReconciliation,
      totalCount, pageSize, currentPage, filterAirlines, filterUsers,
      filterStatus, approveReconciliation, declineReconciliation,
      openEditModal, closeEditModal, isEditModalOpen,
      handleUpdate, handleChange, newAirlineId, newType, airlines,
      selectAirlineChange, selectTypeChange, newToken, newTokenRate,
      narration, pendingReconId, reconciliationTypes, narrationError,
      typeError, tokenError, airlineError,airports,newAirportCode,airportError,filterAirport,
      disabled
    } = this.props;
    return (
      <div>

        <RecordPagination
          fetchMore={fetchReconciliation}
          totalCount={totalCount}
          pageSize={pageSize}
          currentPage={currentPage}
          target={<ReconciliationTableStructure
            classes={classes}
            reconciliationData={reconciliationData}
            filterAirlines={filterAirlines}
            filterUsers={filterUsers}
            filterStatus={filterStatus}
            approveReconciliation={approveReconciliation}
            declineReconciliation={declineReconciliation}
            openEditModal={openEditModal}
            closeEditModal={closeEditModal}
            isEditModalOpen={isEditModalOpen}
            handleUpdate={handleUpdate}
            handleChange={handleChange}
            newAirlineId={newAirlineId}
            newType={newType}
            airlines={airlines}
            selectAirlineChange={selectAirlineChange}
            selectTypeChange={selectTypeChange}
            newToken={newToken}
            newTokenRate={newTokenRate}
            narration={narration}
            pendingReconId={pendingReconId}
            reconciliationTypes={reconciliationTypes}
            airlineError={airlineError}
            narrationError={narrationError}
            tokenError={tokenError}
            typeError={typeError}
            airports={airports}
            newAirportCode={newAirportCode}
            airportError={airportError}
            filterAirport={filterAirport}
            disabled={disabled}
          // isCommentModalOpen={isCommentModalOpen}
          // openCommentModal={openCommentModal}
          // closeCommentModal={closeCommentModal}
          // comment={comment}
          // processName={processName}
          />} />
      </div>
    );
  }
}

export default (withMobileDialog()(withStyles(styles)(MyReconciliationTable)));



// WEBPACK FOOTER //
// ./src/views/Reconciliation/MyReconciliationTable.jsx